export default __webpack_public_path__ + "57c07abf45503678e3f506fa9e76be9f.png";